import React from 'react'
import { Box, Typography, withStyles } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import { BOOK_A_CALL_URL } from '../../logic'
import styles from './styles'

// Strip under the enterprise cards for programs above the 5,000-learner plans.
const Enterprise = ({ classes }) => (
  <Box className={classes.root}>
    <Box>
      <Typography className={classes.heading}>
        Need more than 5,000 learners a year?
      </Typography>
      <Typography className={classes.body}>
        Contact us for a plan sized to your program, with custom learner limits
        and onboarding.
      </Typography>
    </Box>
    <CoreButton
      size="large"
      variant="contained"
      className={classes.button}
      href={BOOK_A_CALL_URL}
      target="_blank"
    >
      Contact Us
    </CoreButton>
  </Box>
)

export default withStyles(styles)(Enterprise)
